import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Ad } from '../../types';

const initialState = {
  ad: {} as Ad,
  ads: [] as Ad[],
};

const adsSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {
    setAd: (state, action: PayloadAction<Ad>) => {
      state.ad = action.payload;
    },
    setAds: (state, action: PayloadAction<Ad[]>) => {
      state.ads = action.payload;
    },
  },
});

export const { setAd, setAds } = adsSlice.actions;

export default adsSlice.reducer;
